import React, { useEffect, useState } from 'react';
import { notification } from 'antd';
import { useNavigate, useParams } from 'react-router';

import {
  bulkUpdateAttractionsItem,
  loadAttractionItem,
} from 'store/slices/attractions/actions';
import { useAppDispatch, useAppSelector } from 'store';
import { urls } from 'store/api';
import { IAttractionItem } from 'store/slices/attractions/interfaces';
import { serializeSelectPriorityItem } from 'utils/mappings';
import { StatusesEnum } from 'constants/status';
import CardSpin from 'components/Card/CardSpin';
import { IFormProps, SampleEditForm } from 'components/Sample/SampleEditForm';
import { EntitySelect } from 'components/form/AsyncSelect/EntitySelect';

interface IProps {
  sortFieldName?: keyof Pick<
    IAttractionItem,
    'sortPriority' | 'sortPriorityMainPage'
  >;
  slug: string;
  params?: Record<string, any>;
}

export const Edit: React.FC<IProps> = ({
  sortFieldName = 'sortPriority',
  slug,
  params = {},
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const { id } = useParams();
  const [queryLoading, setQueryLoading] = useState(!!id);
  const data = useAppSelector(state => state.attractions);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const onSubmit = (params: IFormProps<IAttractionItem>) => {
    const data = params.values;
    const prevItem =
      id && Number(id) != data.id
        ? { id: Number(id), [sortFieldName]: null }
        : {};
    const updateElements = [
      {
        id: data.id,
        [sortFieldName]: params.sortPriority,
      },
      prevItem,
    ].filter(el => el.id);
    dispatch(bulkUpdateAttractionsItem(updateElements))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Cущность успешно изменена',
        });
        navigate(slug);
      })
      .catch(() => setIsLoading(false));
  };
  const initialValues = serializeSelectPriorityItem({
    values: data.item,
    sortFieldName,
  });

  useEffect(() => {
    if (id) {
      dispatch(loadAttractionItem(id))
        .unwrap()
        .finally(() => {
          setQueryLoading(false);
        });
    }
  }, [id]);

  if (queryLoading) {
    return <CardSpin />;
  }
  const handleCancel = () => {
    navigate(slug);
  };

  const Select = () => (
    <EntitySelect
      name='values'
      label='Достопримечательность'
      placeholder='Выберите достопримечательность'
      additional={{
        status: StatusesEnum.PUBLISHED,
        sort: `${sortFieldName}`,
        ...params,
      }}
      required
      requestUrl={urls.api.attractions.get}
    />
  );

  return (
    <SampleEditForm
      initialValues={initialValues}
      onSubmit={onSubmit}
      handleCancel={handleCancel}
      isLoading={isLoading}
      select={Select}
    />
  );
};
